import { copy as sharedUiCopy } from '@shared/copy';
import { Skeleton, SkeletonLines } from '@shared/ui/Skeleton';

/**
 * The pending state of `/editorial/:postId`.
 *
 * The cover plate first, at the post's own `12/5` ratio, then the headline and
 * the opening lines of the body. The ratio is what holds the page still: an
 * editorial cover is the tallest thing on the surface, and a placeholder at the
 * wrong ratio moves everything under it by the difference.
 */
export function EditorialDetailSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <div className="grid gap-4">
        <Skeleton className="aspect-[12/5] w-full rounded-md" />
        <Skeleton className="h-8 w-2/3" />
        <SkeletonLines lines={3} />
      </div>
    </>
  );
}
